import type { EditorState } from '../store/editorState';

const getIsStageLoading = (state: EditorState) => state.stageLoader.isLoading;

export { getIsStageLoading };
